/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/no-array-index-key */
import React from 'react';
import { advSearchState } from 'Stores/advSearch';
import { observer } from 'mobx-react';
import { userDetail } from 'Stores/userDetail';
import { advSearchFilterPopupState } from 'Stores/advSearchFIlterPopup';
import companySearchState from 'Stores/companySearch';
import * as CONSTANTS from 'Utils/constants';

import { Utils } from 'Utils/utils';
import Button from 'Components/common/Button';
import { ToggleType } from 'Components/common/Toggle';
import { ReactComponent as InfoIcon } from 'Assets/svg/info-icon.svg';
import { ReactComponent as ArrowIcon } from 'Assets/svg/right-arrow.svg';
import { ReactComponent as WarningIcon } from 'Assets/svg/warning-circle-icon.svg';
import { ReactComponent as PlusIcon } from 'Assets/svg/plus-icon.svg';
import { ReactComponent as SearchIcon } from 'Assets/svg/open-search.svg';
import { ReactComponent as LockIcon } from 'Assets/svg/lock.svg';

const InputBoxWithoutSuggestion = observer(props => {
  const {
    inputVal,
    placeholder,
    setInputVal,
    suggestionKey,
    filterInPage,
    blockedKey,
    currentTab = 'contact',
    allowExcludeFilter = false,
    isExcludeEnabled = false,
    includeExcludeToggleCbk = () => {},
    excludeToolTipInfo = '',
  } = props;
  const [inputFocus, setInputFocus] = React.useState(false);

  const [showTitleInfo, setShowTitleInfo] = React.useState('');

  let currentSelectedState;
  let commonFocusOutIntervalObj;
  if (currentTab === 'contact')
    if (filterInPage) {
      currentSelectedState = advSearchState;
    } else {
      currentSelectedState = advSearchFilterPopupState;
    }
  else currentSelectedState = companySearchState;
  const selectedObj =
    currentSelectedState.appliedFilterData[suggestionKey] || [];

  const onInputChange = e => {
    const inpVal = e.currentTarget.value;
    if (showTitleInfo !== 'TITLE_MAX_LIMIT') setInputVal(inpVal);
  };

  const onInputBlur = (e, isBlur = true) => {
    if (e) e.preventDefault();
    if (
      inputVal !== '' &&
      ((showTitleInfo === 'TITLE_INFO' && !isBlur) || showTitleInfo === '') &&
      showTitleInfo !== 'TITLE_MAX_LIMIT'
    ) {
      const inputArr = inputVal.split(',');
      if (inputArr.length) {
        const arrObj = [];
        // eslint-disable-next-line array-callback-return
        inputArr.map(item => {
          const newObj = {};
          if (item.trim() !== '') {
            newObj.pName = item.trim();
            arrObj.push(newObj);
          }
        });

        if (
          currentSelectedState.appliedFilterSectionData[suggestionKey] &&
          currentSelectedState.appliedFilterSectionData[suggestionKey] !==
            undefined
        ) {
          const previousData =
            currentSelectedState.appliedFilterSectionData[suggestionKey];

          if (previousData.length > 0)
            // eslint-disable-next-line array-callback-return
            previousData.map(item => {
              const newObj = {};
              newObj.pName = item.trim();
              arrObj.push(newObj);
            });
        }

        const mxDataMap = {};
        if (currentTab === 'contact')
          if (filterInPage) mxDataMap.filterPlace = 'page';
          else mxDataMap.filterPlace = 'popup';
        else mxDataMap.filterPlace = 'page';

        const { isFreeTrial } = userDetail;

        mxDataMap.isFreeTrial = isFreeTrial;
        mxDataMap.searchValue = inputVal;

        mxDataMap.currentTab = currentTab;
        mxDataMap.filterKey = suggestionKey;

        switch (suggestionKey) {
          case 'title':
          case 'excludeTitle':
            mxDataMap.isIncluded = true;
            mxDataMap.titleSearch = inputVal;
            if (suggestionKey === 'excludeTitle') mxDataMap.isIncluded = false;
            Utils.mixpanelTrack(
              CONSTANTS.MX_AS_EVENTS.AS_TITLE_SEARCH_PERFORMED,
              mxDataMap,
            );
            break;
          case 'name':
            mxDataMap.nameSearch = inputVal;
            Utils.mixpanelTrack(
              CONSTANTS.MX_AS_EVENTS.AS_LEAD_NAME_SEARCH_PERFORMED,
              mxDataMap,
            );
            break;
          case 'zip':
            mxDataMap.zipSearch = inputVal;
            Utils.mixpanelTrack(
              CONSTANTS.MX_AS_EVENTS.AS_ZIP_SEARCH_PERFORMED,
              mxDataMap,
            );
            break;

          default:
            Utils.mixpanelTrack('AS Common Search Performed', mxDataMap);
            break;
        }

        currentSelectedState.setAppliedFilters(
          suggestionKey,
          arrObj,
          null,
          true,
        );
        setInputVal('');
      }
    }

    if (isBlur)
      if (showTitleInfo === 'TITLE_INFO')
        commonFocusOutIntervalObj = setInterval(() => {
          setInputFocus(false);
          clearInterval(commonFocusOutIntervalObj);
        }, 200);
      else setInputFocus(false);

    setShowTitleInfo('');
  };

  const onInputKeyPress = e => {
    if (e && e.charCode && e.charCode === 13)
      // || e.charCode === 44
      onInputBlur(null, false);
  };

  const onInputFocus = e => {
    if (!inputFocus) setInputFocus(true);
  };

  const clearUpgradePopup = onMouseEnter => {
    if (onMouseEnter)
      Utils.mixpanelTrack(CONSTANTS.MX_AS_EVENTS.AS_WEB_PAYWALL_VIEWED, {
        type: `Search Filters - ${blockedKey}`,
      });

    const eleList = document.getElementsByClassName('show-upgrade-popup');
    if (eleList !== undefined && eleList.length > 0)
      for (let i = 0; i < eleList.length; i += 1)
        eleList[i].classList.remove('show-upgrade-popup');
    const maskEle = document.getElementsByClassName('upgradePopupMask');
    if (filterInPage) maskEle[0].classList.remove('showMask');
    else maskEle[1].classList.remove('showMask');
  };

  const showUpgradePopup = event => {
    Utils.mixpanelTrack(CONSTANTS.MX_AS_EVENTS.AS_WEB_PAYWALL_CLICKED, {
      type: `Search Filters - ${blockedKey}`,
    });
    clearUpgradePopup();
    if (event !== undefined)
      event.currentTarget.classList.add('show-upgrade-popup');

    const maskEle = document.getElementsByClassName('upgradePopupMask');
    if (filterInPage) maskEle[0].classList.add('showMask');
    else maskEle[1].classList.add('showMask');
  };

  const showPricingPopup = (e, key) => {
    if (e !== null) e.stopPropagation();
    Utils.upgradeNowClick('filters');
  };

  const onPlusClick = (e, key) => {
    document.getElementById(key).focus();
  };

  const titleOkGotIt = e => {
    if (e) e.preventDefault();
    Utils.setLocalStorage('titleFilterInfoShown', 'true');
    setShowTitleInfo('');
  };

  const infoBoxClick = e => {
    if (e) e.preventDefault();
    if (commonFocusOutIntervalObj) clearInterval(commonFocusOutIntervalObj);
    if (showTitleInfo === 'TITLE_INFO') {
      document.getElementById(suggestionKey).focus();
      setInputFocus(true);
    }
  };

  React.useEffect(() => {
    const titleFilterInfoShown = Utils.getLocalStorage('titleFilterInfoShown');
    if (suggestionKey === 'title' && inputFocus)
      if (selectedObj.length >= 20) setShowTitleInfo('TITLE_MAX_LIMIT');
      else if (
        inputVal.length < 4 &&
        (titleFilterInfoShown === null || titleFilterInfoShown !== true)
      )
        setShowTitleInfo('TITLE_INFO');
      else setShowTitleInfo('');
  }, [inputFocus, inputVal]);

  return (
    <>
      <div
        className={`input-section ${inputFocus ? 'input-focused' : ''}${
          filterInPage ? ' page-suggestion' : ' popup-suggestion'
        }`}
      >
        <input
          className="input-box"
          value={inputVal}
          type="text"
          placeholder={placeholder}
          onChange={onInputChange}
          onBlur={e => onInputBlur(e, true)}
          onFocus={onInputFocus}
          onKeyPress={onInputKeyPress}
          id={suggestionKey}
          autoComplete="new-password"
        />
        <span className="focus-border" />
        {selectedObj.length > 0 ? (
          <div className="dropdown-icon selected-count">
            <span>{selectedObj.length}</span>
          </div>
        ) : (
          !inputFocus && (
            // <i className="fa fa-plus dropdown-icon" aria-hidden="true" />
            <SearchIcon
              className="dropdown-icon plus-icon"
              width={14}
              height={14}
              onClick={e => onPlusClick(e, suggestionKey)}
            />
          )
        )}
        <div
          className={`suggestion-list search-enter animatedFast ${
            inputVal !== '' ? '' : ' hide-suggestion'
          }${inputFocus ? ' box-design-shadow' : ''}`}
        >
          <div className="suggestion-list-wrap">
            <div
              className="suggestion-item"
              onClick={e => onInputBlur(e, true)}
            >
              <i className="material-icons">search</i>
              {inputVal}
            </div>
          </div>
        </div>
        {showTitleInfo === 'TITLE_INFO' && (
          <div
            className="title-special-info animatedFast animatedDropDown"
            onClick={infoBoxClick}
          >
            <div className="top-wrap">
              You can perform search with: <br />{' '}
              <span className="highlight-text">And / Or / Not</span>
            </div>
            <div className="middle-wrap">
              Example:
              <br />
              <span className="highlight-text">CEO and CFO</span>
            </div>
            <div className="bottom-wrap">
              <Button
                btnText="Ok, Got it"
                icon={false}
                iconName=""
                type="button"
                className="action-btn"
                svg={
                  <ArrowIcon className="arrow-right" width={14} height={18} />
                }
                click={e => titleOkGotIt(e)}
              />
            </div>
          </div>
        )}
        {showTitleInfo === 'TITLE_MAX_LIMIT' && (
          <div className="title-special-info title-max-limit-info animatedFast animatedDropDown">
            <div className="info-wrapper">
              <WarningIcon />
              <div className="info-text">
                You have reached a maximum limit of 20 titles.
              </div>
            </div>
          </div>
        )}
      </div>

      {allowExcludeFilter ? (
        <div className="include-exclude-toggle icon-text-wrapper">
          <ToggleType
            firstText="Include"
            toggle={isExcludeEnabled}
            offer={false}
            cbk={includeExcludeToggleCbk}
            lastText="Exclude"
            showSharpPoint
          />
          <div className="icon-container">
            <InfoIcon width={18} height={18} className="title-info-icon" />
            <div className="tooltip-wrap">
              <span className="tooltip">{excludeToolTipInfo}</span>
              <span className="sharp-point" />
            </div>
          </div>
        </div>
      ) : (
        ''
      )}
    </>
  );
});

export { InputBoxWithoutSuggestion };
export default InputBoxWithoutSuggestion;
